import { FieldValues, Path } from "react-hook-form";

import { Input } from "@/components/Form/Base/input.component";

type HiddenFieldProps<T extends FieldValues> = {
    name: Path<T>;
};

const HiddenField = <T extends FieldValues>({ name }: HiddenFieldProps<T>) => {
    return (
        <Input
            name={name}
            type="hidden"
            id={name}
        />
    );
};

export { HiddenField };
